import { iSelectOptionType } from "../../definitions/interfaces"
import { InitialUsersAction } from "../user/types"

export const ADD_DATA = "ADD_DATA"
export const UPDATE_DATA = "UPDATE_DATA"

export interface DataState {
  data: Array<string>
  users: Array<iSelectOptionType<string>>
}

interface iData {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Array<any>
  total: number
}

export interface SetDataAction {
  type: typeof ADD_DATA
  payload: iData
}

export interface UpdateDataAction {
  type: typeof UPDATE_DATA
  payload: iData
}

export type DataActionTypes =
  | SetDataAction
  | UpdateDataAction
  | InitialUsersAction
